/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramFavouritesUserControllerAddManyMutationRequest,
  TelegramFavouritesUserControllerAddManyMutationResponse,
  TelegramFavouritesUserControllerAddMany401,
} from '../types/TelegramFavouritesUserControllerAddMany.ts';

function getTelegramFavouritesUserAddManyUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/favourites/many` as const };
  return res;
}

/**
 * {@link /api/user/telegram/favourites/many}
 */
export async function telegramFavouritesUserAddMany(
  data: TelegramFavouritesUserControllerAddManyMutationRequest,
  config: Partial<RequestConfig<TelegramFavouritesUserControllerAddManyMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramFavouritesUserControllerAddManyMutationResponse,
    ResponseErrorConfig<TelegramFavouritesUserControllerAddMany401>,
    TelegramFavouritesUserControllerAddManyMutationRequest
  >({ method: 'POST', url: getTelegramFavouritesUserAddManyUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
